
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyre/[...tyre]",
      function () {
        return require("private-next-pages/tyre/[...tyre].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyre/[...tyre]"])
      });
    }
  